import { Component, OnInit, OnDestroy, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort, MatTableDataSource, MatPaginator,MatInput, MatDialog } from '@angular/material';
import { ReportService } from '../report.service';
import { getLocationType, getCustomizedGeo } from '../report';
import { report_leftmenu, NewDeviceTypeDesc, enumReportState, enumgetResidentData } from '../../../app-settings';
import { SessionCheckwithStaff } from '../../../app-general';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { AddAssetComponent } from '../../asset/add-asset/add-asset.component';
import { ReportEditassetComponent } from '../report-editasset/report-editasset.component';
import { MainLayoutService } from '../../../main-layout/main-layout.service';
import { InfrastructureAlertsComponent } from '../../../main-layout/alerts/infrastructure-alerts/infrastructure-alerts.component';
import { SidenavComponent } from '../../../main-layout/sidenav/sidenav.component';
import { ReportHeaderComponent } from '../report-header/report-header.component';

@Component({
  selector: 'app-customizegeo',
  templateUrl: './customizegeo.component.html',
  styleUrls: ['./customizegeo.component.scss']
})
export class CustomizegeoComponent implements OnInit {
  ReportType = report_leftmenu.customizegeoReport;
  private _onDestroy: Subject<void> = new Subject<void>();
  public EnumNewDeviceType = NewDeviceTypeDesc;
  public EnumReportState = enumReportState;
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  mdcurrentScreenWidth: string = 'md';

  constructor(private reportService: ReportService, private mediaObserver: MediaObserver, public dialog: MatDialog, private router: Router,
    public mainLayoutService:MainLayoutService) { 
      mediaObserver.media$.subscribe((change: MediaChange) => {

        if (change.mqAlias == this.xscurrentScreenWidth) {
          this.setupcusgeoTableforXtrasmallerwidth();
        }
        else if (change.mqAlias == this.smcurrentScreenWidth) {
          this.setupcusgeoTableforsmallerwidth();
        }
        else if (change.mqAlias == this.mdcurrentScreenWidth) {
          this.setupcusgeoTableformidwidth();
        }
        else {
          this.setupcusgeoFullTable();
        }
      });
    }

displayedCustomizeGeoColumns: string[] = ['G_GeoName', 'G_Edit', 'R_TagId', 'G_TruLocation', 'G_Updatedon', 'G_roomcolor'];
SiteId = "1";
todaydate; Todaydate;
customizegeoloading = true;
CustomizeGeoReport;
CustomizeGeoSource;
cusloc_selectStateBy;
selectedLocationType;
LocationType;
chkCustomizeGeosearchvalue;
CusLocfilteredArray = [];
cusloc_selstatechange = [];

@ViewChild('searchCusGeoInput') searchCusGeoInput: ElementRef;
@ViewChild('CusGeosort') CusGeosort: MatSort;
@ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();


//CutomizeGeo Reports
setupcusgeoTableforXtrasmallerwidth() {
  this.displayedCustomizeGeoColumns = ['G_GeoName', 'R_TagId', 'G_Updatedon'];
}
setupcusgeoTableforsmallerwidth() {
  this.displayedCustomizeGeoColumns = ['G_GeoName', 'R_TagId', 'G_Updatedon'];
}
setupcusgeoTableformidwidth()
{
  this.displayedCustomizeGeoColumns = ['G_GeoName', 'G_Edit', 'R_TagId', 'G_TruLocation', 'G_Updatedon'];
}
setupcusgeoFullTable() { 
  this.displayedCustomizeGeoColumns = ['G_GeoName', 'G_Edit', 'R_TagId', 'G_TruLocation', 'G_Updatedon', 'G_roomcolor'];
}

  ngOnInit() {
    this.getLocationType();
  }

getLocationType()
{
  try
  {
    this.customizegeoloading = true;     
    var locationtypeitem : getLocationType = 
    {
      siteId:this.SiteId, 
      authKey: localStorage.getItem("Authkey")
    }  
    this.reportService.getLocationType(locationtypeitem).pipe(takeUntil(this._onDestroy))
    .subscribe((LocationTypeReport: any[]) => {               
          this.LocationType = LocationTypeReport;                         
    });    
      this.getCustomizedGeo()  
  }
  catch (err) {
    throw new Error('report.component.ts' + ' - getLocationType() - ' + err.message);
    }  
}


getCustomizedGeo()
{
  try
  {     
    this.customizegeoloading = true;  
    this.searchCusGeoInput.nativeElement.value = ''; 
    var customgeoitem : getCustomizedGeo = 
    {
      siteId:this.SiteId, 
      authKey: localStorage.getItem("Authkey"),
      dateFormat:localStorage.getItem("dateFormat")
    }           
    this.reportService.getCustomizedGeo(customgeoitem).pipe(takeUntil(this._onDestroy))
      .subscribe((CustomizeGeoData: any[]) => {
      this.customizegeoloading = false;  
      this.cusloc_selectStateBy = 0;
      this.selectedLocationType = 0;
      this.CustomizeGeoReport = CustomizeGeoData; 
      
      this.CustomizeGeoSource = new MatTableDataSource(this.CustomizeGeoReport);                  
      this.CustomizeGeoSource.data = CustomizeGeoData;                       
      this.CustomizeGeoSource.paginator = this.paginator.toArray()[0];       
      setTimeout(() => {               
        this.CustomizeGeoSource.sort = this.CusGeosort; 
        this.sortingDatalist_CustomizeGeoReport(this.CustomizeGeoSource);                              
      }, 0);          
              
      });
  }
   catch (err) {
      throw new Error('report.component.ts' + ' - getCustomizedGeo() - ' + err.message);
    } 
}

searchCustomGeoReport(filterValue: string) {
  try
  {
    if(filterValue != null)
    {        
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.CustomizeGeoSource.filter = filterValue;             
      this.chkCustomizeGeosearchvalue = filterValue; 
      this.getfilterCusGeodetails();
      // this.LiveviewData = this.dataSource.filteredData;           
    }
  }
  catch (err) {
    throw new Error('report.component.ts' + ' - searchCustomGeoReport() - ' + err.message);
  }
}

cusloc_selectLocationType(selectLocationType)
{
    try
    {      
          this.selectedLocationType = selectLocationType;
          this.getfilterCusGeodetails();                       
    }
    catch(err)
    {
      throw new Error('report.component.ts' + ' - cusloc_selectLocationType() - ' + err.message);
    }
}

getfilterCusGeodetails()
{
      var _searchfilterData = "";
      var filtersearch;
      var _filterlocationtype = this.selectedLocationType;
      var _filterstatechangedby = this.cusloc_selectStateBy;
      var _filterLiveviewdata;
      var LiveviewfilteredArray = []; 
      _filterLiveviewdata = this.CustomizeGeoReport;
      var chkLiveView = 0;
      
      //////LocationTypefilter////////          
      if(_filterlocationtype == "All")
        _filterLiveviewdata = this.CustomizeGeoReport;
      else if(_filterlocationtype != 0)
      {
        this.CusLocfilteredArray= []; 
        var list = this.CustomizeGeoReport.filter(x => x.roomcolor == _filterlocationtype);
            list.forEach(x => {        
              this.CusLocfilteredArray.push(x);
            }) 
         _filterLiveviewdata = this.CusLocfilteredArray;                
      }
      else
      {
        _filterLiveviewdata = this.CustomizeGeoReport;
      }                     
      
      //////Searchfilter////////            
      if(this.chkCustomizeGeosearchvalue)
      {        
        _searchfilterData = "";
      
        filtersearch = this.chkCustomizeGeosearchvalue; 
              
        var search_roomcolor = "";           
          _searchfilterData = _filterLiveviewdata.filter(function(data)
          {                                                                                 
            if(data.FullTypeName != null)
            {
              search_roomcolor = data.FullTypeName.toLowerCase().includes(filtersearch.toLowerCase());
            }
            else
              search_roomcolor = "";  
                                    
            return data.FullGeoName.toLowerCase().includes(filtersearch.toLowerCase()) || data.FullTruLocation.toLowerCase().includes(filtersearch.toLowerCase()) ||
            data.Updatedon.toLowerCase().includes(filtersearch.toLowerCase()) || search_roomcolor  || 
            data.R_TagId.toString().includes(filtersearch); 
          })           
      }
      else
      {
        _searchfilterData = _filterLiveviewdata;
      }             
      this.CustomizeGeoSource.data = _searchfilterData;           
          setTimeout(() => {        
            this.CustomizeGeoSource.sort = this.CusGeosort;    
            this.sortingDatalist_CustomizeGeoReport(this.CustomizeGeoSource);           
        }, 0);               
}

addAssetdetails()
{
    if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
    let assetData = {Data:this.LocationType,Assetflag:1}
    let dialogRef = this.dialog.open(AddAssetComponent, {
      disableClose: true,
      width: '900px',
      height:'350px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data:assetData
    });
    dialogRef.afterClosed().subscribe(result => {       
    })
}

CusGeo_editAssetName(GeoData)
{    
    if(!SessionCheckwithStaff(this.router))
    {
        return;
    }     
      let dialogRef = this.dialog.open(ReportEditassetComponent, {
        disableClose: true,
        width: '500px',
        height:'250px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data:GeoData
      });
      dialogRef.afterClosed().subscribe(result => {         
        if(result != 'Cancel')
          this.getCustomizedGeo();
    })
}

sortingDatalist_CustomizeGeoReport(DataSource)
{
    DataSource.sortingDataAccessor = function(data, sortHeaderId: string) {  
      
          if(sortHeaderId == 'G_GeoName' || sortHeaderId == 'G_TruLocation' )
          {               
            return data[sortHeaderId].toString().toLocaleLowerCase().trim('');                               
          }   
          else
          { 
            return data[sortHeaderId]; 
          } 
      }
}
CloseRightNav(){  
  if(SidenavComponent.isClosed == false)
  {
      this.mainLayoutService.toggleSideNavRight.emit();
  }
  if(InfrastructureAlertsComponent.isinfraClosed == false)
  {
      this.mainLayoutService.toggleinfrastructureLeft.emit("close");
  } 
  if(ReportHeaderComponent.isReportMenuClosed == false)
  {
      this.reportService.toggleReportMenuNav.emit();
  }
}
ngOnDestroy() {
 this._onDestroy.next();
  this._onDestroy.complete();
}
}
